import pagination from './../public/pagination.vue';

export default {
    name: 'paginationMixin',
    components: { pagination },
    props: [],
    data() {
        return {
            count: 0,
            keyname: null,
            currentPage: 0,
            perPage: 15,
            isLazy: false,

            iniPerPage: 15,
            iniSortField: null,
            iniSortOrder: null,
        };
    },
    computed: {
        pagination: {
            // getter
            get: function () {
                this.perPage; //just for reactivity
                this.currentPage; //just for reactivity
                let values = JSON.parse(localStorage.getItem(`${this.keyname}.pagination`));
                return {
                    keyname: this.keyname,
                    perPage: values && values.perPage ? values.perPage : this.iniPerPage, //default value,
                    isLazy: values && values.isLazy ? values.isLazy : false, //default value,
                    sortField: values && values.sortField ? values.sortField : this.iniSortField,
                    sortOrder: values && values.sortOrder ? values.sortOrder : this.iniSortOrder,
                    currentPage: this.currentPage,
                };
            },
            // setter
            set: function (newValue) {
                this.perPage = newValue.perPage;
                localStorage.setItem(
                    `${this.keyname}.pagination`,
                    JSON.stringify({
                        perPage: newValue.perPage,
                        isLazy: newValue.isLazy,
                        sortField: newValue.sortField,
                        sortOrder: newValue.sortOrder,
                    })
                );

                this.currentPage = newValue.currentPage;
                //if hook exists; execute
                if (typeof this.paginateChange === 'function') {
                    this.paginateChange(newValue);
                }
            },
        },
    },
    created: function () {
        this.keyname = `${this.$options.name}`;
        let values = JSON.parse(localStorage.getItem(`${this.keyname} .pagination`));
        this.perPage = values && values.perPage ? values.perPage : this.iniPerPage; //default value,
        this.isLazy = values && values.isLazy ? values.isLazy : false; //default value,
    },
    methods: {},
};
